import { CvlPaymentStatusEnumType } from '__generated__/graphql';

export default function cvlPaymentStatusToReadable(status: CvlPaymentStatusEnumType): {
  label: string;
  color: string;
} {
  switch (status) {
    case CvlPaymentStatusEnumType.Pending:
      return {
        label: 'Pending',
        color: 'amber',
      };
    case CvlPaymentStatusEnumType.Success:
      return {
        label: 'Success',
        color: 'green',
      };
    case CvlPaymentStatusEnumType.Failed:
      return {
        label: 'Failed',
        color: 'red',
      };
    default:
      return {
        label: status,
        color: 'gray',
      };
  }
}
